import { GLOSSARY_BREADCRUMBS } from 'site-modules/glossary/constants/glossary';
import { getBaseBreadcrumb } from 'site-modules/shared/components/breadcrumbs/helper';

const INVALID_TERMS = ['glossary-categorized-mobile', 'index-mobile'];

export function buildGlossaryTermContentPath(term) {
  return INVALID_TERMS.includes(term) ? '' : `/glossary/${term}`;
}

export function buildGlossaryTermBreadcrumbs(termName, termSlug) {
  return [...GLOSSARY_BREADCRUMBS, getBaseBreadcrumb(termName, `/glossary/${termSlug}.html`)];
}
